import { combineReducers } from 'redux';

import { State, Type } from '../actions/utils';

import initialState from './initial';
import { clearedDefaults, failedDefaults, requestedDefaults, succeededDefaults } from './utils';

export const list = (state: any = initialState.investigations.list, action: any) => {
  switch (action.type) {
    case State.actionCleared(Type.GET_INVESTIGATIONS):
      return clearedDefaults(state);
    case State.actionRequested(Type.GET_INVESTIGATIONS):
      return requestedDefaults(state);
    case State.actionSucceeded(Type.GET_INVESTIGATIONS):
      return succeededDefaults(state, action);
    case State.actionSucceeded(Type.LOGOUT):
    case State.actionSucceeded(Type.SWITCH_ACCOUNT):
    case State.actionSucceeded(Type.CREATE_ACCOUNT):
      return initialState.investigations.list;
    case State.actionFailed(Type.GET_INVESTIGATIONS):
      return failedDefaults(state, action);
    default:
      return state;
  }
};

export default combineReducers({
  list,
});
